<template>
    <div class="flex justify-center">
        <div class="mb-3 w-96">
            <label :for="id" class="form-label mb-2 p-button p-button-primary">{{title}}</label>
            <input
            @input="setFileToUpload($event.target.files[0])"
            :id="id"
            type="file" class="form-control"
            :accept="'.' + allowedExt.join(',.')"
            >
            <span>
                <!-- show if error not null -->
                <small v-if="error_text" id="name-help" class="p-error">{{error_text}}</small>
            </span>
        </div>
    </div>
</template>

<script>
import Dialog from "primevue/dialog";
import Button from "primevue/button";

export default {
    name: "DeleteDialog",
    components: {
        Dialog,
        Button
    },
    props: {
        id : {
            type : String,
            default : 'file_input'
        },
        file_input_title: {
            type: String,
            default: 'Pilih File ... ',
        },
        modelValue  : {
            type : Object,
            default : null
        },
        allowedExt : {
            type : Array,
            default : () => {
                return ['pdf'];
            }
        },
        maxFileSize : {
            type : Number,
            default : 1000000
        },
    },
    // emits: ['update:visible', 'delete'],
    data() {
        return {
            title : this.file_input_title,
            
            error_text : null,
        };
    },
    mounted () {
        this.title = this.file_input_title;
    },
    computed : {
        model : {
            get() {
                return this.modelValue;
            },
            set(value) {
                // console.log(value);
                this.$emit('update:modelValue', value);
            }
        }
    },
    methods: {
        setFileToUpload(file) {
            this.error_text = null;
            // check file extension & mime type to match with allowext
            var ext = file.name.split('.').pop();
            if (this.allowedExt.indexOf(ext) == -1) {
                this.error_text = 'File tidak diizinkan';
                return;
            }

            // check file size
            if (file.size > this.maxFileSize) {
                this.error_text = 'File terlalu besar';
                return;
            }


            // console.log(file);
            this.model = file;
            this.title = file.name;
        },
    }
}
</script>

<style scoped>
input[type="file"] {
    display: none;
}
</style>
